import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.to-string.js";
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
var _withScopeId = function _withScopeId(n) {
  return _pushScopeId("data-v-8dec3c0e"), n = n(), _popScopeId(), n;
};
var _hoisted_1 = {
  class: "home"
};
var _hoisted_2 = {
  class: "homepageContainer"
};
var _hoisted_3 = {
  class: "overview-title"
};
var _hoisted_4 = {
  class: "controlLine"
};
var _hoisted_5 = {
  class: "connected-platforms-label"
};
var _hoisted_6 = {
  class: "filters-block"
};
var _hoisted_7 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("span", {
    class: "connected-platforms-sorting-btn-separator"
  }, null, -1);
});
var _hoisted_8 = {
  class: "create-platform-block"
};
var _hoisted_9 = {
  class: "create-platform-block__label"
};
var _hoisted_10 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", null, null, -1);
});
var _hoisted_11 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", null, null, -1);
});
var _hoisted_12 = {
  class: "tableContainer"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_w_icon = _resolveComponent("w-icon");
  var _component_w_standard_button = _resolveComponent("w-standard-button");
  var _component_MainTitle = _resolveComponent("MainTitle");
  var _component_Banner = _resolveComponent("Banner");
  var _component_TotalSummaries = _resolveComponent("TotalSummaries");
  var _component_w_search_bar = _resolveComponent("w-search-bar");
  var _component_sort_dropdown = _resolveComponent("sort-dropdown");
  var _component_CardInteractive = _resolveComponent("CardInteractive");
  var _component_GridItem = _resolveComponent("GridItem");
  var _component_PlatformPreview = _resolveComponent("PlatformPreview");
  var _component_infinite_loading = _resolveComponent("infinite-loading");
  var _component_GridLayout = _resolveComponent("GridLayout");
  var _component_PlatformsTable = _resolveComponent("PlatformsTable");
  var _component_CenterTop = _resolveComponent("CenterTop");
  var _component_add_platform = _resolveComponent("add-platform");
  var _component_create_platform = _resolveComponent("create-platform");
  var _component_i18n_t = _resolveComponent("i18n-t");
  var _component_standard_notification_dialog = _resolveComponent("standard-notification-dialog");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_CenterTop, null, {
    default: _withCtx(function () {
      return [_createElementVNode("div", _hoisted_2, [_createVNode(_component_MainTitle, null, {
        title: _withCtx(function () {
          return [_createTextVNode(_toDisplayString(_ctx.$t('platforms_management.title')), 1)];
        }),
        default: _withCtx(function () {
          return [_createVNode(_component_w_standard_button, {
            class: "connect-platform-btn",
            type: "primary",
            minWidth: "223px",
            disabled: !_ctx.isPlatformConnect,
            onClick: _cache[0] || (_cache[0] = function ($event) {
              return _ctx.toggleConnectPlatformDialog = true;
            })
          }, {
            default: _withCtx(function () {
              return [_createVNode(_component_w_icon, {
                icon: "link-variant"
              }), _createTextVNode(" " + _toDisplayString(_ctx.$t('platforms_management.connect_platform_btn')), 1)];
            }),
            _: 1
          }, 8, ["disabled"])];
        }),
        _: 1
      }), !!_ctx.errorMsg ? (_openBlock(), _createBlock(_component_Banner, {
        key: 0,
        type: "error"
      }, {
        default: _withCtx(function () {
          return [_createTextVNode(_toDisplayString(_ctx.errorMsg), 1)];
        }),
        _: 1
      })) : _createCommentVNode("", true), _createElementVNode("div", null, [_createElementVNode("p", _hoisted_3, _toDisplayString(_ctx.$t('platforms_management.overview.title')), 1), _createVNode(_component_TotalSummaries)]), _createElementVNode("div", _hoisted_4, [_createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.$t('platforms_management.connected_platforms_section.title')), 1), _createElementVNode("div", _hoisted_6, [_createVNode(_component_w_search_bar, {
        placeholder: _ctx.$t('platforms_management.connected_platforms_section.search_platform_placeholder'),
        width: "254px",
        onOnInputUpdate: _ctx.onSearchInputUpdate
      }, null, 8, ["placeholder", "onOnInputUpdate"]), _createVNode(_component_sort_dropdown, {
        placement: "bottom-end",
        onOnItemSelected: _ctx.onSortChanges
      }, null, 8, ["onOnItemSelected"]), _hoisted_7, _createVNode(_component_w_icon, {
        icon: _ctx.isHomepageSimpleview ? 'view-list-outline' : 'view-module-outline',
        size: "22px",
        class: "connected-platforms-view-mode-toggle",
        onClick: _ctx.toggleSimpleView
      }, null, 8, ["icon", "onClick"])])]), _ctx.isHomepageSimpleview ? (_openBlock(), _createBlock(_component_GridLayout, {
        key: 1
      }, {
        default: _withCtx(function () {
          return [_createVNode(_component_GridItem, {
            class: "grid-item"
          }, {
            default: _withCtx(function () {
              return [_createElementVNode("div", {
                class: _normalizeClass("".concat(!_ctx.isPlatformCreator ? 'platform-creation-link--disabled' : '')),
                onClick: _cache[1] || (_cache[1] = function ($event) {
                  return _ctx.togglePlatformCreationDialog = true;
                })
              }, [_createVNode(_component_CardInteractive, {
                class: "create-platform-card"
              }, {
                default: _withCtx(function () {
                  return [_createElementVNode("div", _hoisted_8, [_createVNode(_component_w_icon, {
                    icon: "plus",
                    size: "48px",
                    class: "create-platform-block__icon"
                  }), _createElementVNode("p", _hoisted_9, _toDisplayString(_ctx.$t('platforms_management.connected_platforms_section.platform_creation_btn')), 1)])];
                }),
                _: 1
              })], 2)];
            }),
            _: 1
          }), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.platforms, function (platform) {
            return _openBlock(), _createBlock(_component_GridItem, {
              class: "grid-item",
              key: platform.platformID
            }, {
              default: _withCtx(function () {
                return [_createVNode(_component_PlatformPreview, {
                  platform: platform,
                  loading: _ctx.pfLoading[platform.platformID] !== false,
                  errorMsg: _ctx.pfErrorMsg[platform.platformID]
                }, null, 8, ["platform", "loading", "errorMsg"])];
              }),
              _: 2
            }, 1024);
          }), 128)), _createVNode(_component_infinite_loading, {
            onInfinite: _ctx.debounceInfinite,
            identifier: _ctx.infiniteLoaderID
          }, {
            "no-more": _withCtx(function () {
              return [_hoisted_10];
            }),
            "no-results": _withCtx(function () {
              return [_hoisted_11];
            }),
            _: 1
          }, 8, ["onInfinite", "identifier"])];
        }),
        _: 1
      })) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_12, [!_ctx.isHomepageSimpleview ? (_openBlock(), _createBlock(_component_PlatformsTable, {
        key: 0
      })) : _createCommentVNode("", true)])])];
    }),
    _: 1
  }), _createVNode(_component_add_platform, {
    "toggle-connect-platform-dialog": _ctx.toggleConnectPlatformDialog,
    onDialogClose: _cache[2] || (_cache[2] = function ($event) {
      return _ctx.toggleConnectPlatformDialog = false;
    })
  }, null, 8, ["toggle-connect-platform-dialog"]), _createVNode(_component_create_platform, {
    "toggle-platform-creation-dialog": _ctx.togglePlatformCreationDialog,
    onDialogClose: _cache[3] || (_cache[3] = function ($event) {
      return _ctx.togglePlatformCreationDialog = false;
    })
  }, null, 8, ["toggle-platform-creation-dialog"]), _ctx.shouldSuggestPlatformConnection() ? (_openBlock(), _createBlock(_component_standard_notification_dialog, {
    key: 0,
    title: _ctx.$t('home.initialization_dialog.title'),
    "toggle-dialog": _ctx.togglePlatformConnectionSuggestDialog
  }, {
    footer: _withCtx(function () {
      return [_createVNode(_component_w_standard_button, {
        type: "primary",
        "min-width": "199px",
        onClick: _ctx.onUserAcceptToConnectPlatform
      }, {
        default: _withCtx(function () {
          return [_createTextVNode(_toDisplayString(_ctx.$t('home.initialization_dialog.confirm_btn').toString()), 1)];
        }),
        _: 1
      }, 8, ["onClick"])];
    }),
    default: _withCtx(function () {
      return [_createVNode(_component_i18n_t, {
        scope: "global",
        keypath: "home.initialization_dialog.message.value",
        tag: "div"
      }, {
        first_step: _withCtx(function () {
          return [_createElementVNode("b", null, _toDisplayString(_ctx.$t('home.initialization_dialog.message.first_step')) + ": ", 1)];
        }),
        _: 1
      })];
    }),
    _: 1
  }, 8, ["title", "toggle-dialog"])) : _createCommentVNode("", true)]);
}